const CACHE_KEY = 'cached_user_profile';

export interface CachedUserProfile {
  organizationId: string;
  user: AppUser;
}

export function readProfileCache(): CachedUserProfile | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CachedUserProfile;
  } catch {
    return null;
  }
}

export function writeProfileCache(entry: CachedUserProfile): void {
  localStorage.setItem(CACHE_KEY, JSON.stringify(entry));
}

export function clearProfileCache(): void {
  localStorage.removeItem(CACHE_KEY);
}
